import Vue from "vue";
import Router from "vue-router";

/**page */
import Login from "@/views/member/login";
import Register from "@/views/member/register";
import ForgetPwd from "@/views/member/forget-pwd";
// import Member from "@/views/member";
import MemberCenter from "@/views/member/member-center";
import MessageCenter from "@/views/member/message-center";
import SettingPage from "@/views/member/setting-page";
import AddressList from "@/views/member/address-list";
import EditAddress from "@/views/member/edit-address";
import AccountSafety from "@/views/member/account-safety";
import EditPwd from "@/views/member/edit-pwd";
import EditPhone from "@/views/member/edit-phone";
import PersonData from "@/views/member/personal-data";
import BasicInfo from "@/views/member/basic-info";
import QualitificationCertificate from "@/views/member/qualitification-certificate";
import ClinicPreference from "@/views/member/clinic-preference";
import AllCertificates from "@/views/member/all-certificates";
import Apply from "@/views/member/apply";
import ApplyMuscle from "@/views/member/apply-muscle";
import ApplyLocate from "@/views/member/apply-locate";
import ApplyDetailLocate from "@/views/member/apply-detail-locate";
import ApplyDetailMuscle from "@/views/member/apply-detail-muscle";
import ApplyAddress from "@/views/member/apply-address";
import Tool from "@/views/member/tool";
import MessagePushSetting from "@/views/member/message-push-setting"
// 微信推送查看详情数据
const WinxinForm = () =>
    import("@/views/static-page/weixinForm");
const DesignconfirmDetail = () =>
    import("@/views/static-page/designconfirm-detail");

/**病例列表管理 */
const PatientManageList = () =>
    import("@/views/patient-manage");
const PatientSearch = () =>
    import("@/views/patient-manage/search");
const PatientStatistics = () =>
    import("@/views/patient-manage/statistics");
//病例详情
const PatientDetail = () =>
    import("@/views/patient-detail");
const PatientNoteSheet = () =>
    import("@/views/patient-detail/noteSheet");
const PatientCaseData = () =>
    import("@/views/patient-detail/caseData");
const CasePdf = () =>
    import("@/views/patient-detail/casePdf");
const PatientImageData = () =>
    import("@/views/patient-detail/imageData");
const PatientPreview = () =>
    import("@/views/patient-detail/preview");
const PatientPreviewNew = () =>
    import("@/views/patient-detail/preview-new");
const PatientProductUpgrade = () =>
    import("@/views/patient-detail/productUpgrade");
const PatientDetailInfo = () =>
    import("@/views/patient-detail/patientInfo");
const PatientRemark = () =>
    import("@/views/patient-detail/remark");
const PatientInvite = () =>
    import("@/views/patient-detail/inviteCode");
const inviteRule = () =>
    import("@/views/patient-detail/inviteRule");
const DesignConfirm = () =>
    import("@/views/patient-detail/designConfirm");
//物流详情
const logisticsList = () =>
    import("@/views/patient-detail/logistics/list")
const logisticsDetail = () =>
    import("@/views/patient-detail/logistics/detail")
//佩戴详情
const wearDetails = () =>
    import("@/views/patient-detail/wearDetails");
const stageDetail = () =>
    import("@/views/patient-detail/wearDetails/stageDetail");
const wearList = () =>
    import("@/views/patient-detail/wearDetails/wearList");
const stageList = () =>
    import("@/views/patient-detail/wearDetails/stageList");
const wearDuration = () =>
    import("@/views/patient-detail/wearDetails/wearDuration");
// 发送医嘱
const doctorAdvice = () =>
    import("@/views/patient-detail/doctorAdvice");
const adviceTemplate = () =>
    import("@/views/patient-detail/doctorAdvice/adviceTemplate");
const addAdvice = () =>
    import("@/views/patient-detail/doctorAdvice/addAdvice");
// 中期反馈
const feedbackList = () =>
    import("@/views/patient-detail/feedback");
const feedbackDetail = () =>
    import("@/views/patient-detail/feedback/feedbackDetail");
//复诊资料
const addReCase = () =>
    import("@/views/patient-detail/reCase");
//精细调整
const Adjustment = () =>
    import("@/views/adjustment");
const AdjustmentFeedback = () =>
    import("@/views/adjustment/feedback");
const AdjustmentPhotoUpload = () =>
    import("@/views/adjustment/photo-upload");
const AdjustmentModelSubmit = () =>
    import("@/views/adjustment/model-submit");
const AdjustmentPreview = () =>
    import("@/views/adjustment/preview");
//结束治疗
const PatientEndTherapy = () =>
    import("@/views/end-therapy");
const PatientEndTherapyPhotoUpload = () =>
    import("@/views/end-therapy/photo-upload");
const PatientEndTherapyInsurance = () =>
    import("@/views/end-therapy/insurance");
const PatientEndTherapyAgreement = () =>
    import("@/views/end-therapy/agreement");
const PatientEndTherapyCompletion = () =>
    import("@/views/end-therapy/completion");
const PatientEndTherapyPreview = () =>
    import("@/views/end-therapy/preview");
//病例重启
const CaseRestart = () =>
    import("@/views/case-restart");
const CaseRestartFeedback = () =>
    import("@/views/case-restart/feedback");
const CaseRestartPhotoUpload = () =>
    import("@/views/case-restart/photo-upload");
const CaseRestartModelSubmit = () =>
    import("@/views/case-restart/model-submit");
const CaseRestartPreview = () =>
    import("@/views/case-restart/preview");

//创建病例
const CreatePatient = () =>
    import("@/views/create-patient");
const CreatePatientBaseInfo = () =>
    import("@/views/create-patient/base-info");
const CreatePatientDiagnosticMsg = () =>
    import("@/views/create-patient/diagnostic-msg");
const CreatePatientSixElementDiagnosticMsg = () =>
    import("@/views/create-patient/six-element-diagnostic-msg");
const CreatePatientImageData = () =>
    import("@/views/create-patient/image-data");
const CreatePatientModelSubmit = () =>
    import("@/views/create-patient/model-submit");
const CreatePatientModelSubmitNew = () =>
    import("@/views/create-patient-new/model-submit");
//新版病例提交单
const CreatePatientNew = () =>
    import("@/views/create-patient-new");
const CreatePatientBaseInfoNew = () =>
    import("@/views/create-patient-new/base-info");
const CreatePatientDiagnosticMsgNew = () =>
    import("@/views/create-patient-new/diagnostic-msg");
const CreatePatientSixElementDiagnosticMsgNew = () =>
    import("@/views/create-patient-new/six-element-diagnostic-msg");
const CreateSpecialPatientDiagnosticMsgNew = () =>
    import("@/views/create-patient-new/special-diagnostic-msg");
const CreateChildPatientDiagnosticMsgNew = () =>
    import("@/views/create-patient-new/child-diagnostic-msg");
const CreateBracePatientDiagnosticMsgNew = () =>
    import("@/views/create-patient-new/brace-diagnostic-msg");
const CreateS17PatientDiagnosticMsgNew = () =>
    import("@/views/create-patient-new/s17-diagnostic-msg");
const CreateEarlyPatientDiagnosticMsgNew = () => 
    import("@/views/create-patient-new/early-diagnostic-msg");
//修改新病例照片
const EditNewCasePhoto = () =>
    import("@/views/create-patient/edit-image-data")
//动画
const DesignAnimation = () =>
    import("@/views/design-animation");
const DesignGoal = () =>
    import("@/views/design-goal");
//绑定账号
const BindAccountHome = () =>
    import("@/views/bind-account");
const BindAccount = () =>
    import("@/views/bind-account/bind");
const BindAccountSuccess = () =>
    import("@/views/bind-account/success");

//销售微信绑定
const SalesWechatBindingHome = () =>
    import("@/views/sales-wechat-binding");
const SalesWechatBinding = () =>
    import("@/views/sales-wechat-binding/bind");
const SalesWechatBindingSuccess = () =>
    import("@/views/sales-wechat-binding/success");
//机构微信绑定
const OrganizationWechatBindingHome = () =>
    import("@/views/organization-wechat-binding");
const OrganizationWechatBinding = () =>
    import("@/views/organization-wechat-binding/bind");
const OrganizationWechatBindingSuccess = () =>
    import("@/views/organization-wechat-binding/success");
//正雅互动
const Interaction = () =>
    import("@/views/interaction");
const InteractionShareData = () =>
    import("@/views/interaction/share-data/index");
// const InteractionVideoView = () => import("@/views/interaction/share-data/video-view");
// const InteractionPdfView = () => import("@/views/interaction/share-data/pdf-view");
const InteractionCommonProblem = () =>
    import("@/views/interaction/common-problem/index");
const InteractionCommonProblemDetail = () =>
    import("@/views/interaction/common-problem/detail");
const InteractionFeedback = () =>
    import("@/views/interaction/feedback");
const InteractionMyFeedback = () =>
    import("@/views/interaction/my-feedback");
const FeedbackInteraction = () =>
    import("@/views/interaction/my-feedback/interaction");
const FeedbackInteractionDetail = () =>
    import("@/views/interaction/my-feedback/detail");
const FeedbackInteractionEdit = () =>
    import("@/views/interaction/my-feedback/edit");
//文件查看-pdf/video
const FileViewPdf = () =>
    import("@/views/file-view/pdf");
const FileViewVideo = () =>
    import("@/views/file-view/video");
//静态页面
const StaticPageAboutUs = () =>
    import("@/views/static-page/about-us");
const StaticPageAddress = () =>
    import("@/views/static-page/address");
const StaticPagePrivacyProtocol = () =>
    import("@/views/static-page/privacy-protocol");
const StaticPagePrivacyPolicy = () =>
    import("@/views/static-page/privacyPolicy");
const StaticPagePrivacyPolicyAndroid = () =>
    import("@/views/static-page/privacyPolicy-android");

const StaticPagePrivacyPolicyEn = () =>
    import("@/views/static-page/privacy-policy-en")

const AppStaticPagePrivacyProtocol = () =>
    import("@/views/static-page/app-privacy-protocol");
const AppMarketCaseBank = () =>
    import("@/views/static-page/app-market-case-bank");
const TestWeixin = () =>
    import("@/views/static-page/testWeixin");
const AppPayDetail = () =>
    import("@/views/static-page/app-pay-detail");
const StaticPageRegisterProtocol = () =>
    import("@/views/static-page/register-protocol");
const AppStaticPageRegisterProtocol = () =>
    import("@/views/static-page/app-register-protocol");
const StaticPageGuideCm = () =>
    import("@/views/static-page/guide-cm");
const StaticPageGuideCert = () =>
    import("@/views/static-page/guide-cert");
const AppPopularize = () =>
    import("@/views/static-page/app-popularize");
// csa项目病例说明
const CsaDetail = () =>
    import("@/views/static-page/csa-detail")
const StaticPagePrivacyProtocolEn = () =>
    import("@/views/static-page/privacy-protocol-en")
const StaticPageRegisterProtocolEn = () =>
    import("@/views/static-page/register-protocol-en")
const ElectronicCard = () => import("@/views/app-page/electronic-card/base")
//补发矫治器
const ReissueAppliance = () =>
    import("@/views/reissue-appliance/index");
const PreviewReissueAppliance = () =>
    import("@/views/reissue-appliance/preview")
//追加保持器
const AppendAppliance = () =>
    import("@/views/append-appliance/index")
const PreviewAppendAppliance = () =>
    import("@/views/append-appliance/preview")
//市场扫描注册活动
const ScanActivityRegister = () =>
    import("@/views/scan-activity/register")
const ScanActivityInvestigation = () =>
    import("@/views/scan-activity/investigation")
const ScanActivitySuccess = () =>
    import("@/views/scan-activity/success")
//页面公用
const Layout = () =>
    import("@/views/layout");
//404
import ErrorPage from "@/views/error-page";

// 微笑测试
const smileTest = () =>
    import("@/views/static-page/smileTest/index")
// 微笑测试
const smileTestPC = () =>
    import("@/views/static-page/smileTestPC/index")
Vue.use(Router);
export const constantRouterMap = [{
    path: "/signIn",
    name: "Login",
    component: Login,
    meta: {
        title: "登录"
    }
},
{
    path: "/designconfirm-detail",
    name: "designconfirm-detail",
    component: DesignconfirmDetail,
    meta: {
        title: "订单完成通知详情"
    }
},
{
    path: "/winxinForm",
    name: "WinxinForm",
    component: WinxinForm,
    meta: {
        title: "订单完成通知详情"
    }
},
{
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
        title: "注册"
    }
},
{
    path: "/forget-pwd",
    name: "ForgetPwd",
    component: ForgetPwd,
    meta: {
        title: "忘记密码"
    }
},
{
    path: "/app-privacy-protocol",
    component: AppStaticPagePrivacyProtocol,
    meta: {
        title: "隐私政策"
    }
},
{
    path: "/member",
    redirect: "/member/member-center",
    name: "Member",
    component: Layout,
    children: [{
        path: "/member-center",
        name: "MemberCenter",
        component: MemberCenter,
        meta: {
            title: "用户中心"
        }
    },
    {
        path: "/message-center",
        name: "MessageCenter",
        component: MessageCenter,
        meta: {
            title: "信息中心"
        }
    },
    {
        path: "/setting-page",
        name: "SettingPage",
        component: SettingPage,
        meta: {
            title: "设置"
        }
    },
    {
        path: "/address-list",
        name: "AddressList",
        component: AddressList,
        meta: {
            title: "地址"
        }
    },
    {
        path: "/add-address",
        name: "createAddress",
        component: EditAddress,
        meta: {
            title: "新增收货地址"
        }
    },
    {
        path: "/edit-address/:id",
        name: "EditAddress",
        component: EditAddress,
        meta: {
            title: "编辑收货地址"
        }
    },
    {
        path: "/account-safety",
        name: "AccountSafety",
        component: AccountSafety,
        meta: {
            title: "账号安全"
        }
    },
    {
        path: "/message-push-setting",
        name: "MessagePushSetting",
        component: MessagePushSetting,
        meta: {
            title: "推送设置"
        }
    },
    {
        path: "/edit-phone",
        name: "EditPhone",
        component: EditPhone,
        meta: {
            title: "编辑联系方式"
        }
    },
    {
        path: "/edit-pwd",
        name: "EditPwd",
        component: EditPwd,
        meta: {
            title: "修改密码"
        }
    },
    {
        path: "/person-data",
        name: "PersonData",
        component: PersonData,
        meta: {
            title: "个人信息"
        }
    },
    {
        path: "/basic-info",
        name: "BasicInfo",
        component: BasicInfo,
        meta: {
            title: "基本信息"
        }
    },
    {
        path: "/qualitification-certificate",
        name: "QualitificationCertificate",
        component: QualitificationCertificate,
        meta: {
            title: "证书"
        }
    },
    {
        path: "/clinic-preference",
        name: "ClinicPreference",
        component: ClinicPreference,
        meta: {
            title: "临床偏好"
        }
    },
    {
        path: "/all-certificates",
        name: "AllCertificates",
        component: AllCertificates,
        meta: {
            title: "星级证书"
        }
    },
    {
        path: "/apply",
        name: "Apply",
        component: Apply,
        meta: {
            title: "我的申请"
        }
    },
    {
        path: "/apply-locate",
        name: "ApplyLocate",
        component: ApplyLocate,
        meta: {
            title: "正畸定位器申请申明"
        }
    },
    {
        path: "/apply-muscle",
        name: "ApplyMuscle",
        component: ApplyMuscle,
        meta: {
            title: "肌功能评估工具包"
        }
    },
    {
        path: "/apply-detail-locate",
        name: "ApplyDetailLocate",
        component: ApplyDetailLocate,
        meta: {
            title: "正畸定位器借用申请详情"
        }
    },
    {
        path: "/apply-detail-muscle",
        name: "ApplyDetailMuscle",
        component: ApplyDetailMuscle,
        meta: {
            title: "肌功能评估工具包借用申请详情"
        }
    },
    {
        path: "/apply-address",
        name: "ApplyAddress",
        component: ApplyAddress,
        meta: {
            title: "正畸定位器借用申请"
        }
    },
    {
        path: "/tool",
        name: "tool",
        component: Tool,
        meta: {
            title: "突面畸形诊断工具",
            noFooter: true
        }
    },
    ]
},
//病例管理
{
    path: "",
    redirect: "/patient-manage"
},
{
    path: "/patient-manage",
    redirect: "/patient-manage/list",
    name: "PatientManage",
    component: Layout,
    children: [{
        path: "list",
        name: "PatientManageList",
        component: PatientManageList,
        meta: {
            title: "病例管理"
        }
    },
    {
        path: "search",
        name: "PatientSearch",
        component: PatientSearch,
        meta: {
            title: "病例搜索"
        }
    },
    {
        path: "statistics",
        name: "PatientStatistics",
        component: PatientStatistics,
        meta: {
            title: "病例统计"
        }
    }
    ]
},
//病例详情
{
    path: "/patient-detail/:id",
    redirect: "/patient-detail/:id/home",
    component: Layout,
    children: [{
        path: "edit-patient-photo",
        name: "EditPatientPhoto",
        component: CreatePatientImageData,
        meta: {
            title: "修改照片"
        }
    },
    {
        path: "edit-new-case-photo/:groupID",
        name: "EditNewCasePhoto",
        component: EditNewCasePhoto,
        meta: {
            title: "修改照片"
        }
    },
    {
        path: "edit-adjustment-photo/:AdjustId",
        name: "EditAdjustmentPhoto",
        component: AdjustmentPhotoUpload,
        meta: {
            title: "修改照片"
        }
    },
    {
        path: "edit-restart-photo/:RestartId",
        name: "EditRestartPhoto",
        component: CaseRestartPhotoUpload,
        meta: {
            title: "修改照片"
        }
    },
    {
        path: "edit-end-photo/:CaseOrderEndID",
        name: "EditEndPhoto",
        component: PatientEndTherapyPhotoUpload,
        meta: {
            title: "修改照片"
        }
    },
    {
        path: "home",
        name: "PatientDetail",
        component: PatientDetail,
        meta: {
            title: "病例详情"
        }
    },
    {
        path: "note-sheet",
        name: "PatientNoteSheet",
        component: PatientNoteSheet,
        meta: {
            title: "说明表"
        }
    },
    {
        path: "case-data",
        name: "PatientCaseData",
        component: PatientCaseData,
        meta: {
            title: "病例资料"
        }
    },
    {
        path: "case-pdf",
        name: "casePdf",
        component: CasePdf,
        meta: {
            title: "诊断资料"
        }
    },
    {
        path: "image-data",
        name: "PatientImageData",
        component: PatientImageData,
        meta: {
            title: "影像资料"
        }
    },
    {
        path: "preview",
        name: "PatientPreview",
        component: PatientPreview,
        meta: {
            title: "病例预览"
        }
    },
    {
        path: "preview-new",
        name: "PatientPreviewNew",
        component: PatientPreviewNew,
        meta: {
            title: "病例预览"
        }
    },
    {
        path: "design-confirm/:caseDesignID/:indicationID/:caseMainID/:tipType/:fromType",
        name: "DesignConfirm",
        component: DesignConfirm,
        meta: {
            title: "动画确认"
        }
    },
    {
        path: "product-upgrade",
        name: "PatientProductUpgrade",
        component: PatientProductUpgrade,
        meta: {
            title: "产系升级"
        }
    },
    // guandong_20220907
    {
        path: "patientDetailInfo",
        name: "PatientDetailInfo",
        component: PatientDetailInfo,
        meta: {
            title: "修改患者信息"
        }
    },
    {
        path: "remark",
        name: "PatientRemark",
        component: PatientRemark,
        meta: {
            title: "病例备注"
        }
    },
    {
        path: "patient-invite",
        name: "patientInvite",
        component: PatientInvite,
        meta: {
            title: "邀请函"
        }
    },
    {
        path: "wear-details",
        name: "wearDetails",
        component: wearDetails,
        meta: {
            title: "佩戴详情"
        }
    },
    {
        path: "wear-list/:StepID",
        name: "wearList",
        component: wearList,
        meta: {
            title: "佩戴明细"
        }
    },
    {
        path: "wear-duration/:StepID",
        name: "wearDuration",
        component: wearDuration,
        meta: {
            title: "时长未达标天数"
        }
    },
    {
        path: "stage-list",
        name: "stageList",
        component: stageList,
        meta: {
            title: "历史阶段信息"
        }
    },
    {
        path: "stage-detail/:StepID/:stagePresentPhase",
        name: "stageDetail",
        component: stageDetail,
        meta: {
            title: "历史阶段信息详情"
        }
    },
    {
        path: "doctor-advice",
        name: "doctorAdvice",
        component: doctorAdvice,
        meta: {
            title: "医患沟通"
        }
    },
    {
        path: "advice-template",
        name: "adviceTemplate",
        component: adviceTemplate,
        meta: {
            title: "医嘱模板"
        }
    },
    {
        path: "add-advice/:MedicalInterationID",
        name: "addAdvice",
        component: addAdvice,
        meta: {
            title: "新增医嘱",
            keepAlive: true, ///此组件需要缓存
            isBack: false, //用来判断是否是返回上一页
        }
    },
    {
        path: "feedback-list",
        name: "feedbackList",
        component: feedbackList,
        meta: {
            title: "中期反馈"
        }
    },
    {
        path: "feedback-detail/:FeedBackID",
        name: "feedbackDetail",
        component: feedbackDetail,
        meta: {
            title: "反馈信息"
        }
    },
    {
        path: "add-recase",
        name: "AddReCase",
        component: addReCase,
        meta: {
            title: "新增复诊资料"
        }
    },
    {
        path: "logistics-list",
        name: "LogisticsList",
        component: logisticsList,
        meta: {
            title: "物流查询"
        }
    },
    {
        path: "logistics-detail/:no/:address",
        name: "LogisticsDetail",
        component: logisticsDetail,
        meta: {
            title: "物流详情"
        }
    },
    // 英文版精调重启预览
    {
        path: "/refinement-en/:id",
        component: () => import("@/views/patient-detail/refinement-en"),
        meta: {
            title: "Case View"
        },
        name: 'refinementEn'
    },
    {
        path: "/restart-en/:id",
        component: () => import("@/views/patient-detail/restart-en"),
        meta: {
            title: "Case View"
        },
        name: 'restartEn'
    }]
},
//精细调整
{
    path: "/adjustment/:CaseMainID",
    redirect: "/adjustment/:CaseMainID/home",
    component: Layout,
    children: [{
        path: "home",
        name: "Adjustment",
        component: Adjustment,
        meta: {
            title: "创建精调病例"
        }
    },
    {
        path: "feedback",
        name: "AdjustmentFeedback",
        component: AdjustmentFeedback,
        meta: {
            title: "中期反馈"
        }
    },
    {
        path: "photo-upload",
        name: "AdjustmentPhotoUpload",
        component: AdjustmentPhotoUpload,
        meta: {
            title: "图像上传"
        }
    },
    {
        path: "model-submit",
        name: "AdjustmentModelSubmit",
        component: AdjustmentModelSubmit,
        meta: {
            title: "模型提交"
        }
    },
    {
        path: "/adjustment/:AdjustTreatPlanID/preview",
        name: "AdjustmentPreview",
        component: AdjustmentPreview,
        meta: {
            title: "精调预览"
        }
    }
    ]
},
//补发矫治器
{
    path: "/reissue-appliance/:caseMainID/:id/:type",
    redirect: "/reissue-appliance/:caseMainID/:id/:type/home",
    component: Layout,
    children: [{
        path: "home",
        name: "ReissueAppliance",
        component: ReissueAppliance,
        meta: {
            title: "补发矫治器"
        }
    },
    {
        path: "/reissue-appliance/:caseMainID/:id/preview",
        name: "PreviewReissueAppliance",
        component: PreviewReissueAppliance,
        meta: {
            title: "预览补发矫治器"
        }
    },
    ]
},
//追加保持器
{
    path: "/append-appliance/:caseMainID/:id/:type",
    redirect: "/append-appliance/:caseMainID/:id/:type/home",
    component: Layout,
    children: [{
        path: "home",
        name: "AppendAppliance",
        component: AppendAppliance,
        meta: {
            title: "追加保持器"
        }
    },
    {
        path: "/append-appliance/:caseMainID/:id/preview",
        name: "PreviewAppendAppliance",
        component: PreviewAppendAppliance,
        meta: {
            title: "预览追加保持器"
        }
    },
    ]
},
//结束治疗
{
    path: "/end-therapy/:CaseMainID",
    redirect: "/end-therapy/:CaseMainID/home",
    component: Layout,
    children: [{
        path: "home",
        name: "PatientEndTherapy",
        component: PatientEndTherapy,
        meta: {
            title: "结束治疗"
        }
    },
    {
        path: "photo-upload",
        name: "PatientEndTherapyPhotoUpload",
        component: PatientEndTherapyPhotoUpload,
        meta: {
            title: "矫治完成后照片"
        }
    },
    {
        path: "insurance",
        name: "PatientEndTherapyInsurance",
        component: PatientEndTherapyInsurance,
        meta: {
            title: "后保资料"
        }
    },
    {
        path: "agreement",
        name: "PatientEndTherapyAgreement",
        component: PatientEndTherapyAgreement,
        meta: {
            title: "隐形矫治结束同意书"
        }
    },
    {
        path: "completion",
        name: "PatientEndTherapyCompletion",
        component: PatientEndTherapyCompletion,
        meta: {
            title: "矫治完成情况"
        }
    },
    {
        path: "/end-therapy/:CaseOrderEndID/preview",
        name: "PatientEndTherapyPreview",
        component: PatientEndTherapyPreview,
        meta: {
            title: "结束治疗详情预览"
        }
    }
    ]
},
//病例重启
{
    path: "/case-restart/:CaseMainID",
    redirect: "/case-restart/:CaseMainID/home",
    component: Layout,
    children: [{
        path: "home",
        name: "CaseRestart",
        component: CaseRestart,
        meta: {
            title: "重启病例"
        }
    },
    {
        path: "feedback",
        name: "CaseRestartFeedback",
        component: CaseRestartFeedback,
        meta: {
            title: "重启病例"
        }
    },
    {
        path: "photo-upload",
        name: "CaseRestartPhotoUpload",
        component: CaseRestartPhotoUpload,
        meta: {
            title: "重启病例"
        }
    },
    {
        path: "model-submit",
        name: "CaseRestartModelSubmit",
        component: CaseRestartModelSubmit,
        meta: {
            title: "重启病例"
        }
    },
    {
        path: "/case-restart/:RestartTreatPlanID/preview",
        name: "CaseRestartPreview",
        component: CaseRestartPreview,
        meta: {
            title: "新病例重启详情预览"
        }
    }
    ]
},
//创建病例
{
    path: "/create-patient/:id",
    redirect: "/create-patient/:id/home",
    component: Layout,
    children: [{
        path: "home",
        name: "CreatePatient",
        component: CreatePatient,
        meta: {
            title: "创建病例"
        }
    },
    {
        path: "base-info",
        name: "CreatePatientBaseInfo",
        component: CreatePatientBaseInfo,
        meta: {
            title: "创建病例",
            keepAlive: false
        }
    },
    {
        path: "diagnostic-msg",
        mame: "CreatePatientDiagnosticMsg",
        component: CreatePatientDiagnosticMsg,
        meta: {
            title: "诊断说明",
            keepAlive: false
        }
    },
    {
        path: "six-element-diagnostic-msg",
        mame: "CreatePatientSixElementDiagnosticMsg",
        component: CreatePatientSixElementDiagnosticMsg,
        meta: {
            title: "诊断说明",
            keepAlive: false
        }
    },
    {
        path: "image-data",
        name: "CreatePatientImageData",
        component: CreatePatientImageData,
        meta: {
            title: "影像资料",
            keepAlive: false
        }
    },
    {
        path: "model-submit",
        name: "CreatePatientModelSubmit",
        component: CreatePatientModelSubmit,
        meta: {
            title: "模型提交",
            keepAlive: false
        }
    }
    ]
},
//新版创建病例
{
    path: "/create-patient-new/:id",
    redirect: "/create-patient-new/:id/home-new",
    component: Layout,
    children: [{
        path: "home-new",
        name: "CreatePatientNew",
        component: CreatePatientNew,
        meta: {
            title: "创建病例"
        }
    },
    {
        path: "base-info-new",
        name: "CreatePatientBaseInfoNew",
        component: CreatePatientBaseInfoNew,
        meta: {
            title: "创建病例",
            keepAlive: false
        }
    },
    {
        path: "diagnostic-msg",
        name: "CreatePatientDiagnosticMsgNew",
        component: CreatePatientDiagnosticMsgNew,
        meta: {
            title: "诊断说明",
            keepAlive: false
        }
    },
    {
        path: "six-element-diagnostic-msg",
        name: "CreatePatientSixElementDiagnosticMsgNew",
        component: CreatePatientSixElementDiagnosticMsgNew,
        meta: {
            title: "诊断说明",
            keepAlive: false
        }
    },
    {
        path: "special-diagnostic-msg",
        name: "CreateSpecialPatientDiagnosticMsgNew",
        component: CreateSpecialPatientDiagnosticMsgNew,
        meta: {
            title: "诊断说明",
            keepAlive: false
        }
    },
    {
        path: "child-diagnostic-msg",
        name: "CreateChildPatientDiagnosticMsgNew",
        component: CreateChildPatientDiagnosticMsgNew,
        meta: {
            title: "诊断说明",
            keepAlive: false
        }
    },
    {
        path: "brace-diagnostic-msg",
        name: "CreateBracePatientDiagnosticMsgNew",
        component: CreateBracePatientDiagnosticMsgNew,
        meta: {
            title: "诊断说明",
            keepAlive: false
        }
    },
    {
        path: "s17-diagnostic-msg",
        name: "CreateS17PatientDiagnosticMsgNew",
        component: CreateS17PatientDiagnosticMsgNew,
        meta: {
            title: "诊断说明",
            keepAlive: false
        }
    },
    {
        path: "early-diagnostic-msg",
        name: "CreateEarlyPatientDiagnosticMsgNew",
        component: CreateEarlyPatientDiagnosticMsgNew,
        meta: {
            title: "诊断说明",
            keepAlive: false
        }
    },

    {
        path: "image-data-new",
        name: "CreatePatientImageDataNew",
        component: CreatePatientImageData,
        meta: {
            title: "影像资料",
            keepAlive: false
        }
    },
    {
        path: "model-submit-new",
        name: "CreatePatientModelSubmitNew",
        component: CreatePatientModelSubmitNew,
        meta: {
            title: "模型提交",
            keepAlive: false
        }
    }
    ]
},
//动画嵌套页面
{
    path: "/design-animation/:designID/:caseMainID",
    name: "DesignAnimation",
    component: DesignAnimation,
    meta: {
        title: "动画设计"
    }
},
//目标位设计动画
{
    path: "/design-goal/:caseDesignAimID/:caseMainID",
    name: "DesignGoal",
    component: DesignGoal,
    meta: {
        title: "动画设计"
    }
},
//绑定页面
{
    path: "/bind-account",
    component: BindAccountHome,
    children: [{
        path: "",
        name: "BindAccount",
        component: BindAccount,
        meta: {
            title: "绑定账号"
        }
    },
    {
        path: "success",
        name: "BindAccountSuccess",
        component: BindAccountSuccess,
        meta: {
            title: "绑定成功"
        }
    }
    ]
},
//销售微信绑定页面
{
    path: "/sales-wechat-binding",
    component: SalesWechatBindingHome,
    children: [{
        path: "",
        name: "SalesWechatBinding",
        component: SalesWechatBinding,
        meta: {
            title: "绑定账号"
        }
    },
    {
        path: "success",
        name: "SalesWechatBindingSuccess",
        component: SalesWechatBindingSuccess,
        meta: {
            title: "绑定成功"
        }
    }
    ]
},
//机构微信绑定页面
{
    path: "/organization-wechat-binding",
    component: OrganizationWechatBindingHome,
    children: [{
        path: "",
        name: "OrganizationWechatBinding",
        component: OrganizationWechatBinding,
        meta: {
            title: "绑定账号"
        }
    },
    {
        path: "success",
        name: "OrganizationWechatBindingSuccess",
        component: OrganizationWechatBindingSuccess,
        meta: {
            title: "绑定成功"
        }
    }
    ]
},
//正雅互动
{
    path: "/interaction",
    redirect: "/interaction/home",
    component: Layout,
    children: [{
        path: "home",
        name: "Interaction",
        component: Interaction,
        meta: {
            title: "正雅互动"
        }
    },
    {
        path: "share-data",
        name: "InteractionShareData",
        component: InteractionShareData,
        meta: {
            title: "常用资料"
        }
    },
    // {
    //     path: "video-view",
    //     name: "InteractionVideoView",
    //     component: InteractionVideoView,
    //     meta: {
    //         title: "视频查看"
    //     }
    // },
    // {
    //     path: "pdf-view",
    //     name: "InteractionPdfView",
    //     component: InteractionPdfView,
    //     meta: {
    //         title: "文件查看"
    //     }
    // },
    {
        path: "common-problem",
        name: "InteractionCommonProblem",
        component: InteractionCommonProblem,
        meta: {
            title: "常见问题"
        }
    },
    {
        path: "problem-detail/:id",
        name: "InteractionCommonProblemDetail",
        component: InteractionCommonProblemDetail,
        meta: {
            title: "常见问题详情"
        }
    },
    {
        path: "feedback",
        name: "InteractionFeedback",
        component: InteractionFeedback,
        meta: {
            title: "我要反馈"
        }
    },
    {
        path: "my-feedback",
        name: "InteractionMyFeedback",
        component: InteractionMyFeedback,
        meta: {
            title: "我的反馈"
        }
    },
    {
        path: "feedback-interaction/:id",
        name: "FeedbackInteraction",
        component: FeedbackInteraction,
        meta: {
            title: "反馈互动"
        }
    },
    {
        path: "detail/:detailID/:btnType",
        name: "FeedbackInteractionDetail",
        component: FeedbackInteractionDetail,
        meta: {
            title: "反馈详情"
        }
    },
    {
        path: "edit/:detailID/:btnType",
        name: "FeedbackInteractionEdit",
        component: FeedbackInteractionEdit,
        meta: {
            title: "修改反馈"
        }
    }
    ]
},
//市场扫描注册活动
{
    path: "/scan-activity",
    redirect: "/login",
    component: { template: "<router-view></router-view>" },
    children: [{
        path: "/login",
        name: "ScanActivityRegister",
        component: ScanActivityRegister,
        meta: {
            title: "注册"
        }
    },
    {
        path: "investigation",
        name: "ScanActivityInvestigation",
        component: ScanActivityInvestigation,
        meta: {
            title: "信息调查"
        }
    },
    {
        path: "success",
        name: "ScanActivitySuccess",
        component: ScanActivitySuccess,
        meta: {
            title: "注册成功"
        }
    }
    ]
},
//静态页面-协议/填写指引等
{
    path: "/file-view",
    component: { template: "<router-view></router-view>" },
    children: [{
        path: "pdf",
        name: "FileViewPdf",
        component: FileViewPdf,
        meta: {
            title: "文件查看"
        }
    },
    {
        path: "video",
        name: "FileViewVideo",
        component: FileViewVideo,
        meta: {
            title: "文件查看"
        }
    }
    ]
},
//邀请函
{
    path: "/invite",
    component: { template: "<router-view></router-view>" },
    children: [{
        path: "invite-rule",
        name: "inviteRule",
        component: inviteRule,
        meta: {
            title: "邀请指引"
        }
    },]
},
//静态页面-协议/填写指引等
{
    path: "/static-page",
    component: { template: "<router-view></router-view>" },
    children: [{
        path: "/guide-cm",
        name: "StaticPageGuideCm",
        component: StaticPageGuideCm,
        meta: {
            title: "CM序列号填写引导"
        }
    },
    {
        path: "/smileTest",
        component: smileTest,
        meta: {
            title: "完美微笑"
        }
    },
    {
        path: "/smileTestPC",
        component: smileTestPC,
        meta: {
            title: "完美微笑"
        }
    },
    
    {
        path: "/app-market-case-bank/:id",
        component: AppMarketCaseBank,
        meta: {
            title: "优秀病例详情"
        }
    },
    {
        path: "/testWeixin",
        component: TestWeixin,
        meta: {
            title: "testWeixin"
        }
    },
    {
        path: "/app-pay-detail",
        component: AppPayDetail,
        meta: {
            title: "付款详情"
        }
    },
    {
        path: "/guide-cert",
        name: "StaticPageGuideCert",
        component: StaticPageGuideCert,
        meta: {
            title: "医生资格证书填写引导"
        }
    },
    {
        path: "/about-us",
        name: "StaticPageAboutUs",
        component: StaticPageAboutUs,
        meta: {
            title: "关于我们"
        }
    },
    {
        path: "/address-commponents",
        component: StaticPageAddress,
        meta: {
            title: "地址测试"
        }
    },
    {
        path: "/privacy-protocol",
        component: StaticPagePrivacyProtocol,
        meta: {
            title: "隐私政策"
        }
    },
    {
        path: "/privacyPolicy",
        component: StaticPagePrivacyPolicy,
        meta: {
            title: "隐私政策"
        }
    },
    {
        path: "/privacyPolicy-android",
        component: StaticPagePrivacyPolicyAndroid,
        meta: {
            title: "隐私政策"
        }
    },
    {
        path: "/privacyPolicyEn",
        component: StaticPagePrivacyPolicyEn,
        meta: {
            title: "Privacy Policy"
        }
    },
    {
        path: "/register-protocol",
        component: StaticPageRegisterProtocol,
        meta: {
            title: "正雅用户服务协议"
        }
    },
    {
        path: "/app-register-protocol",
        component: AppStaticPageRegisterProtocol,
        meta: {
            title: "注册协议"
        }
    },
    {
        path: "/csa-detail",
        name: "CsaDetail",
        component: CsaDetail,
        meta: {
            title: "CSA项目病例说明"
        }
    },
    {
        path: "/privacy-protocol-en",
        component: StaticPagePrivacyProtocolEn,
        meta: {
            title: "Privacy Policy"
        }
    },
    {
        path: "/register-protocol-en",
        component: StaticPageRegisterProtocolEn,
        meta: {
            title: "User Service Agreement of Smartee"
        }
    },
    {
        path: "/app-popularize",
        component: AppPopularize,
        meta: {
            title: "App 下载"
        }
    },
    ]
},
{
    path: "/mobile-payment/:id/:code",
    component: () => import("@/views/mobile-payment/index"),
    meta: {
        title: "手机支付"
    },
    name: 'MobilePayment'
},
{
    path: "/online3-submit-info",
    component: () => import("@/views/patient-detail/online3SubmitInfo"),
    meta: {
        title: "网三病例提交单信息"
    },
    name: 'Online3SubmitInfo'
},
{
    path: "/online3-new-patient/preview",
    component: () => import("@/views/patient-detail/online3PatientPreview"),
    meta: {
        title: "网三新病例预览"
    },
    name: 'Online3PatientPreview'
},
{
    path: "/online3-adjust-patient/preview",
    component: () => import("@/views/patient-detail/online3AdjustPreview"),
    meta: {
        title: "网三精调预览"
    },
    name: 'Online3AdjustmentPreview'
},
{
    path: "/online3-end-patient/preview",
    component: () => import("@/views/patient-detail/online3EndTherapyPreview"),
    meta: {
        title: "网三结束治疗预览"
    },
    name: 'Online3EndTherapyPreview'
},
{
    path: '/electronic-card',
    component: ElectronicCard,
    meta: {
        title: "电子名片"
    },
    name: 'ElectronicCard'
},
{
    path: '/electronic-card-info',
    component: () => import("@/views/app-page/electronic-card"),
    meta: {
        title: "电子名片"
    },
    name: 'ElectronicCardInfo'
},
{
    path: "/end-year/detail",
    component: () => import("@/views/end-year"),
    meta: {
        title: "年终总结"
    },
    name: 'endYear'
},
{
    path: "/online3/end-year/detail",
    component: () => import("@/views/end-year/online3"),
    meta: {
        title: "网3年终总结"
    },
    name: 'online3EndYear'
},
{
    path: "/mine/end-year/detail",
    component: () => import("@/views/end-year/mine"),
    meta: {
        title: "我的年终总结"
    },
    name: 'mineEndYear'
},
{
    path: "/end-year/mine",
    component: () => import("@/views/end-year/components/page1.vue"),
    meta: {
        title: "生成我的年终报告"
    },
    name: 'mineEndYear'
},
{
    path: "/404",
    name: "ErrorPage",
    component: ErrorPage,
    meta: {
        title: "找不到页面"
    }
}
];
export default new Router({
    routes: constantRouterMap
});

/**
 * Do not throw an exception if push is rejected by redirection from navigation guard
 */
const originalPush = Router.push;
Router.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch((err) => {
        let reg = new RegExp('^Redirected when going from "[a-z_.\\/]+" to "[a-z_.\\/]+" via a navigation guard.$');
        if (reg.test(err.message)) {
            // If pushing interrupted because of redirection from navigation guard - ignore it.
            return Promise.resolve(false);
        }
        // Otherwise throw error
        return Promise.reject(err);
    });
};

export const asyncRouterMap = [{ path: "*", redirect: "/404", hidden: true }];


// WEBPACK FOOTER //
// ./src/router/index.js